import React from 'react'
import { MobileStepper } from '@material-ui/core'
import useJourneyWhiteLabel from 'hooks/useJourneyWhiteLabel'

const Stepper = () => {
  const { currentStep, steps } = useJourneyWhiteLabel()

  return (
    <MobileStepper
      variant="dots"
      steps={steps.length}
      position="static"
      activeStep={currentStep}
      backButton={<></>}
      nextButton={<></>}
    />
  )
}

export default Stepper
